import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-chip',
  styleUrl: 'lab-ds-chip.css',
  shadow: true,
})
export class LabDsChip {
  @Event() handleCloseChip: EventEmitter;

  handleClickChip() {
    this.handleCloseChip.emit();
  }

  @Prop() avatar: boolean = false;

  @Prop() size: 'medium' | 'small' = 'medium';

  @Prop() label: string;

  @Prop() nameAvatar: string;

  @Prop() imageSRCAvatar: string;

  render() {
    return (
      <button class={`${this.size} ${this.avatar && 'with-avatar'} chip`}>
        {this.avatar && <lab-ds-avatar imageSRC={this.imageSRCAvatar} name={this.nameAvatar} size="small" />} <span class="label">{this.label}</span>{' '}
        <lab-ds-icon-selectable
          onClick={e => {
            this.handleClickChip();
            e.stopPropagation();
          }}
          class="holder"
          size="small"
          icon="close"
        />
      </button>
    );
  }
}
